import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import {FlexContainer, TitleH4} from 'heliocor-ui'

import dokstorSvg from '../assets/logos/dokstor-logo-svg.svg'


function Logo({dokstor}){
    const customLogo = useSelector(state => state.settings.customLogo)

    const [height, setHeight] = useState(32)

    useEffect(() => {
        if (customLogo) {
            const img = document.createElement('img')
            img.src = customLogo;
            img.onload = function () {
                const w = img.width
                const h = img.height
                if (w/h < 2) setHeight(64)
            }
        }
    }, [customLogo])
    

    if (customLogo && !dokstor) return (
        <FlexContainer alignItems='center'>
            <img style={{height}} src={customLogo || dokstorSvg} alt='logo' />
        </FlexContainer>  
    )

    return(
        <FlexContainer alignItems='center'>
            <img style={{height:26}} src={dokstorSvg} alt='logo' />
            <TitleH4 margin='0 0 0 0.35rem'>CAFe</TitleH4>
        </FlexContainer>
    )
}

export default Logo